export const GainsightEvents = {
  gpuDetected: 'GPU Detected',
  projectSelected: 'Connect Project Selected',
  accountNotAllowed: 'Account Not Allowed',
  regionNotFound: 'Region Not Found',
};
